import { createContext } from "react";

const UserContext =createContext({
    loggedInUser : "AM",
});

export default UserContext;
